export default __webpack_public_path__ + "static/media/MATH_23.af85f9c6.png";